WiseMetering.Collection.ExternalAssets = WiseMetering.Collection.extend({
    model: WiseMetering.Model.ExternalAsset
});

